import { useContext, useEffect, useState } from 'react'
import { NVButton } from '@nv/basic-components'
import { AuthCodeInput } from '@nv/components'
import { OnboardProgressBar } from '@nv/components'
import { LoginFlowContext, useVoterUserContext } from '@nv/contexts'
import { useQuery } from '@nv/hooks'
import { OnlineVoterAuthService } from '@nv/services'
import clsx from 'clsx'
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import styles from './OnBoardingPhoneVerify.module.scss'
import '@djthoms/pretty-checkbox'

export const OnBoardingPhoneVerify = () => {
  const securityAnswerLength = 4
  const { t } = useTranslation()
  const { executeRecaptcha } = useGoogleReCaptcha()
  const LOGIN_CONTEXT = useContext(LoginFlowContext)
  const navigate = useNavigate()
  const query = useQuery()
  const accessCode = query.get('accessCode')
  const [code, setCode] = useState('')
  const [codeError, setCodeError] = useState(null)
  const [notValid, setNotValid] = useState(true)
  const { setVoterUser } = useVoterUserContext()

  const onSubmit = async () => {
    if (!executeRecaptcha) {
      return
    }
    if (!accessCode) {
      setCodeError('auth.login.errors.securityAnswer')
    }

    const token = await executeRecaptcha('voter_onboarding')
    const res = await OnlineVoterAuthService.validateSecurityQuestion(accessCode, code, token)
    if (res.success) {
      setVoterUser(res.user)
      LOGIN_CONTEXT.setLoginFlow('Onboarding')
      navigate('/voting/voter-onboarding/auth-method')
    } else {
      //@ts-ignore
      if (res.error.message === 'recaptcha error') {
        setCodeError('auth.login.errors.recaptcha')
      } else {
        setCodeError('auth.login.errors.securityAnswer')
      }
    }
  }

  useEffect(() => {
    // disabled button handler
    setCodeError('')
    if (code.length === securityAnswerLength) {
      setNotValid(false)
    }
  }, [code])

  useEffect(() => {
    const validateAccessCode = async () => {
      const res = await OnlineVoterAuthService.validateAccessLink(accessCode)
      if (res.error) {
        navigate('/voting/voter-login', { replace: true })
        setCodeError('')
      }
    }
    validateAccessCode()
  }, [accessCode])

  // Automatically submit when input is complete
  useEffect(() => {
    setCodeError('')
    if (code.length === securityAnswerLength) {
      setNotValid(false)
      onSubmit()
    } else {
      setNotValid(true)
    }
  }, [code])

  return (
    <div className={styles['container']}>
      <div className={styles['form']}>
        <OnboardProgressBar currentStep={1} />

        <div className={styles['body']}>
          <span className={styles['body__title']}>{t('auth.login.validations.memberVerify')}</span>

          <span className={styles['instruction']}>
            {t('auth.login.validations.enterSecurityAnswer', {
              digits: securityAnswerLength,
            })}
            <span className={clsx(styles['instruction'], styles['instruction--bold'])}>
              {t('auth.login.labels.username.customSecurityAnswer')}
            </span>
          </span>

          <AuthCodeInput code={code} setCode={setCode} length={securityAnswerLength} codeError={codeError} errorMessage={codeError} />
        </div>

        <div className={styles['footer']}>
          <NVButton text={t('buttons.next')} onClick={onSubmit} disabled={notValid} height={50} />
        </div>
      </div>
    </div>
  )
}
